import { AlertList } from 'modules/campaigns/alerts/components/AlertList';
import { CampaignTypeCard } from 'modules/campaigns/alerts/components/CampaignAlertDefaults/CampaignTypeCard';
import { Blast, Eligibility, Triggered } from 'modules/campaigns/alerts/components/constants';
import { AlertTakeoverCampaign } from 'modules/campaigns/lib/takeovers/AlertTakeover/types';
import { CampaignTypeFilter } from 'modules/domains/campaign';
import { FC } from 'react';
import { useAlertOverridesContext } from './context/AlertOverridesContext';

const getCampaignTypeForAlert = (campaignType: CampaignTypeFilter) => {
  switch (campaignType) {
    case CampaignTypeFilter.Blast:
      return Blast;
    case CampaignTypeFilter.Eligibility:
      return Eligibility;
    default:
      /**
       * As a FYI, campaigns in published journeys are typed 'WorkflowTriggered'
       * in the backend and all other triggered campaigns are 'ApiTriggered'
       *
       * In campaign alerts land, triggered campaigns from both sources are just
       * classified as 'Triggered'
       */
      return Triggered;
  }
};

type OverrideAlertOptionsProps = {
  campaignData: AlertTakeoverCampaign;
};

export const OverrideAlertOptions: FC<OverrideAlertOptionsProps> = ({ campaignData }) => {
  const { messageMedium, campaignType } = campaignData;
  const typeData = getCampaignTypeForAlert(campaignType);
  const { isLoadingOverrides, metrics } = useAlertOverridesContext();

  return (
    <CampaignTypeCard campaignTypeData={typeData} messageMedium={messageMedium}>
      <AlertList
        campaignType={typeData.type}
        isLoading={isLoadingOverrides}
        messageMedium={messageMedium}
        metrics={metrics}
      />
    </CampaignTypeCard>
  );
};
